<script>
    import {onMount} from 'svelte'          
    import Progress from '@src/components/Progress.svelte'
    import Select from '@src/components/Select.svelte'

    import {getResource} from '@src/service'    
    import {locale,language} from '@src/languages.js'
    import routerManager from '@src/router/router'


    const router = routerManager.getRouter('default')
    let showless = true
    let governorate, area, stationNo, model, transNo;

    let resp;
    
    
    function applyState(state){                
        if(state == null) return
        governorate = state.governorate        
        area = state.area 
        stationNo = state.stationNo
        model = state.model
        transNo = state.transNo
        showless = state.showless
    }

     function clearForm(){
        governorate = null
        area = null
        stationNo = null
        model = null
        transNo = null
    }

    onMount(()=>{
        let searchComp = JSON.parse(localStorage.getItem("searchcomp") )        
        applyState(searchComp)                
        resp = getResource('governorates')
    })    

    $: areas = governorate?governorate.areas:[]

    let keyProps = {itemValueKey:'id', itemLabelKey:$locale == 'ar' ? 'name':'name_en'}

    function submit(){

        let params = []                
        if(typeof(governorate) != undefined && governorate !=null){
            params.push('area.governorate_id:eq:' + governorate.id)
        }

        if(typeof(area) != undefined && area != null)
            params.push('area_id:eq:' +  area.id)
        else {
            return
        }    

        
        if(typeof(stationNo) != undefined && stationNo != null){
            params.push('(no:eq:' + stationNo + ';or;no_old:eq:' + stationNo + ")")            

        }

        
        if(typeof(model) != undefined && model != null)
            params.push('model:eq:' +  model)

        
        if(typeof(transNo) != undefined && transNo != null) 
            params.push('transformers_no:eq:' +  transNo)     
        let searchParams = { query : params.join(";and;")}       
        if(area){
            searchParams.area = area
        }
        let state = {
            governorate : governorate || null,
            area : area || null,
            stationNo: stationNo || null,
            model : model || null,
            transNo: transNo || null,
            showless:showless
        }
        
        localStorage.setItem("searchcomp",JSON.stringify(state))
        router.navigate('list',searchParams)
    }


</script>

<div class="h-full w-full overflow-hidden">
    {#await $resp}
         <div class="w-full h-full flex flex-col justify-center">
                <div class="w-full flex flex-row justify-center">
                    <Progress/>
                </div>
            </div>
    {:then governorates}         
        <form on:submit|preventDefault={submit}
        class="flex flex-col gap-3 p-4 mt-4">
        <div class="w-full">
            <label for="governorate" class="w-full block mb-1 p-1 font-bold flex flex-row justify-between">
                <span>{ $language.label_governorate } :</span>
                <h1 class="px-4 pt-1" on:click|preventDefault={clearForm}>
                    <svg viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 3V1.5A1.5 1.5 0 009.5 0h-4A1.5 1.5 0 004 1.5V3H0v1h1v9.5A1.5 1.5 0 002.5 15h10a1.5 1.5 0 001.5-1.5V4h1V3h-4zM5 1.5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5V3H5V1.5zM7 7v5h1V7H7zm-3 5V9h1v3H4zm6-3v3h1V9h-1z" fill="currentColor"></path></svg>
                </h1>
            </label>
            <div class="rounded-full border-2 border-green-400 px-4">                    
                <Select items={governorates} bind:selected={governorate} 
                labelKey={$locale == 'ar'?'name':'name_en' } valueKey={'id'}
                class="w-full p-1" />               
            </div>
        </div>
        <div>
            <label for="area" class="w-full block mb-1 p-1 font-bold">
                <span>{ $language.label_area }</span>
            </label>
            <div class="rounded-full border-2 border-green-400 px-4">
                <Select items={areas} bind:selected={area} labelKey={$locale == 'ar'?'name':'name_en' }
                valueKey={'id'} class="w-full p-1"/>                
            </div>
        </div>        
        <div>
            <label  for="station_no" class="mb-2 block px-2 font-bold">
                <span>{$language.label_station_no}</span>
            </label>
            <input name="station_no" type="text" bind:value={stationNo} class="w-full p-1 rounded-full border-2 border-green-400">
        </div>
        <h3 class="px-4 text-green-400" on:click={()=> showless = ! showless}>
            <span class="text-lg font-bold">{showless?'+':'-'}</span>
            {showless ? $language.label_more : $language.label_less}
        </h3>
        <div class:hidden={showless} >
            <label for="station_model" class="mb-2 font-bold block px-2">
                <span>{$language.label_station_model}</span>
            </label>
            <input name="station_model" type="text" bind:value={model} class="w-full p-1 rounded-full border-2 border-green-400">
        </div>
        <div class:hidden={showless}>
            <label for="area" class="w-full block mb-2 px-2 font-bold">
                <span>{ $language.label_station_transNo }</span>
            </label>
            <div class="rounded-full border-2 border-green-400 px-4">
                <Select items={[2,4,6,8]} bind:selected={transNo} class="w-full p-1"/>            
            </div>
        </div>        
        <div>            
            <button  type="submit" 
                    class=" text-white text-center font-bold rounded-full p-2 w-full bg-green-500">
                    {$language.btn_search}                    
             </button>
        </div>

    </form>
    {:catch error }
        <h1>{error}</h1>
    {/await}
    
</div>